import { UserListTable } from "./UserListTable";
import { Content } from "@/components/ui/ContentArea";
import { Card } from "@/components/Shared/Card";
import { Separator } from "@/components/ui/separator";

export function AdminPage() {
	return (
		<Content className="p-5">
			<Card>
				<h1 className="text-xl font-bold">Listado de Empresas</h1>
				<Separator />
				<UserListTable />
			</Card>
		</Content>
	);
}
